import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { updateAddToCartAction } from "../../middleware/updateAddToCartAction";
import Helper from "../Helper";
import { APPLICATION_JSON } from "../../middleware/types";
import Loader from "../Loader/Loader";
import Product from "./Product";

function FeaturedItems(props) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState(props.containerObject && props.containerObject.attributes && props.containerObject.attributes.title ? props.containerObject.attributes.title : "")
  const [containerObject, setContainerObject] = useState(props.containerObject ? props.containerObject : "")
  const [productDetailsItems, setProductDetailsItems] = useState([])
  const [loader, setLoader] = useState(false)


  const handleQuickViewProductPage = (event) => {
    event.preventDefault()
    props.productCountCallBack("")
    props.productDetailsCallBack("")
    var formData = new FormData(event.target);
    const productId = formData.get("productIdss")
    const productCount = formData.get("productCount")
    fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/product/product-quick-view/${productId}`, {
      method: 'GET'
    }).then(res => res.json())
      .then(res => {
        if (res !== null) {
          //setIsLoading(false)
          //	setProductDetailsView(res)
          var productDetatils = (JSON.parse(res.response)).response
          //props.productDetailsCallBack(productDetatils)
          //	props.productCountCallBack(productCount ? productCount : "")
          document.getElementById("hiddenSharePageModal").click()
        } else {
          //setIsLoading(false)
          //const error = res._ERROR_MESSAGE_;
          //setErrorMessage(error);
          //document.getElementById("login-message-error-div").classList.remove("d-none");
          // console.log("errorMessage ---->>>>!!!!", errorMessage)
        }
      })
  }


  return (
    <>
      {loader ? <Loader /> : ""}
      <div className={`${containerObject && containerObject.attributes && containerObject.attributes.className ? containerObject.attributes.className : ""}`}>
        <div className="featured-items-heading d-flex justify-content-center">
          <div dangerouslySetInnerHTML={{_html : title}}></div>
        </div>
        <div className="row featured-items-list ms-1 col-md-12 mt-4 mb-4">
          <ul className="row justify-content-center">
            <Product containerObject={containerObject ? containerObject : ""}/>
          </ul>
        </div>
      </div >
    </>
  );
}

export default FeaturedItems;